import type { UploadSlot } from '@photo-merge/shared';
import { uploadBall } from '../lib/api';

/** Uploads run a few at a time: enough to be quick, not enough to stall a phone. */
const UPLOAD_CONCURRENCY = 3;

export interface UploadJob {
  slot: UploadSlot;
  blob: Blob;
}

/** Pushes every blob to its slot, reporting each one as it lands. */
export async function uploadAll(
  jobs: UploadJob[],
  onProgress: (done: number, total: number) => void,
): Promise<void> {
  const queue = [...jobs];
  let done = 0;
  const workers = Array.from({ length: UPLOAD_CONCURRENCY }, async () => {
    for (;;) {
      const job = queue.shift();
      if (!job) return;
      await uploadBall(job.slot, job.blob);
      onProgress(++done, jobs.length);
    }
  });
  await Promise.all(workers);
}
